export const SET_TAGS = 'setTags';
export const SET_TAGS_LANG_TYPE = 'setTagsLangType';
export const SET_ERROR = 'setError';
